namespace GeniuzPOS.Lookups {
    export namespace VwBrandTypeService {
        export const baseUrl = 'Lookups/VwBrandType';

        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<VwBrandTypeRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<VwBrandTypeRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Retrieve = "Lookups/VwBrandType/Retrieve",
            List = "Lookups/VwBrandType/List"
        }

        [
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>VwBrandTypeService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
